// import { toggleSidebar } from '../../shop/inc/filters';

import allowClick from '../../helpers/allow-click';

const toggleBusiness = ( ( document ) => {
	// const { toggleBusinessTxt, togglePrivateTxt } = window.l18n_js_theme;
	//
	// const _animateTextChange = ( element, newText ) => {
	// 	const spanEl = element.querySelector( '.toggle-text' );
	// 	element.classList.add( 'forbidden' );
	// 	spanEl.classList.remove( 'fade-in', 'fade-out' );
	// 	spanEl.classList.add( 'fade-out' );
	// 	const onFadeOut = ( e ) => {
	// 		if ( e.propertyName !== 'opacity' ) return;
	// 		spanEl.innerText = newText;
	// 		spanEl.classList.remove( 'fade-out' );
	// 		spanEl.classList.add( 'fade-in' );
	//
	// 		spanEl.addEventListener( 'transitionend', onFadeIn, {
	// 			once: true,
	// 		} );
	// 	};
	//
	// 	const onFadeIn = ( e ) => {
	// 		if ( e.propertyName !== 'opacity' ) return;
	// 		spanEl.classList.remove( 'fade-in' );
	// 		element.classList.remove( 'forbidden' );
	// 	};
	//
	// 	spanEl.addEventListener( 'transitionend', onFadeOut, { once: true } );
	// };
	const _toggleInput = ( btn ) => {
		// const textHolder = btn.querySelector( '.toggle-text' );
		btn.addEventListener( 'click', ( e ) => {
			if ( ! allowClick() ) {
				// e.preventDefault();
			}
			btn.classList.toggle( 'is-active' );
			if (
				document.body.classList.contains( 'force-business-is-active' )
			) {
				document.body.classList.remove( 'force-business-is-active' );
			}
			document.body.classList.toggle( 'business-is-active' );
			if ( btn.classList.contains( 'is-active' ) ) {
				btn.setAttribute( 'aria-expanded', 'true' );
				// textHolder.innerText = toggleBusinessTxt;
				// _animateTextChange( btn, toggleBusinessTxt );
				localStorage.setItem( 'isBusiness', 'true' );
			} else {
				btn.setAttribute( 'aria-expanded', 'false' );
				// _animateTextChange( btn, togglePrivateTxt );
				localStorage.removeItem( 'isBusiness' );
			}

			document.dispatchEvent( new CustomEvent( 'lc:customer-view-change' ) );
		} );
	};
	const _changePosition = ( btn ) => {
		const mediaQuery = window.matchMedia( '(width >= 1350px)' );
		if ( mediaQuery.matches ) {
			const cloneAppend = document.querySelector( '.site-header .wrap' );
			_cloneBtn( cloneAppend );
		}

		mediaQuery.addEventListener( 'change', ( e ) => {
			if ( ! e.matches ) {
				const menuItem = document.querySelector(
					'.menu-item-toggle-business'
				);
				_cloneBtn( menuItem );
			} else {
				const cloneAppend =
					document.querySelector( '.site-header .wrap' );
				_cloneBtn( cloneAppend );
			}
		} );
	};

	const _cloneBtn = ( appender ) => {
		const btn = document.querySelector( '[rel="toggle-business"]' );
		const cloneBtn = btn.cloneNode( true );
		_toggleInput( cloneBtn );
		btn.remove();
		appender.appendChild( cloneBtn );
	};

	const _setView = () => {
		const isFrontpage = document.body.classList.contains( 'front-page' );

		const toggleBtn = document.querySelector( '[rel="toggle-business"]' );
		// const textHolder = toggleBtn.querySelector( '.toggle-text' );
		//if is front page set private household and exit
		// console.log( { isFrontpage } );
		// if ( isFrontpage && ! isBusiness ) {
		if ( isFrontpage ) {
			// textHolder.innerText = togglePrivateTxt;
			document.body.classList.remove(
				'business-is-active',
				'force-business-is-active'
			);
			// toggleBtn.classList.remove( 'is-active' );
			toggleBtn.setAttribute( 'aria-expanded', 'true' );
			// The home page is the private view. Store nothing rather than the
			// string 'false', which every other page read as truthy.
			localStorage.removeItem( 'isBusiness' );
			_toggleInput( toggleBtn );
			return;
		}
		const isBusiness = localStorage.getItem( 'isBusiness' ) === 'true';
		const isForcedBusiness = document.body.classList.contains(
			'force-business-is-active'
		);

		if ( isBusiness || isForcedBusiness ) {
			// textHolder.innerText = toggleBusinessTxt;
			document.body.classList.add( 'business-is-active' );
			document.body.classList.add( 'sidebar-active' );
			toggleBtn.classList.add( 'is-active' );
			toggleBtn.setAttribute( 'aria-expanded', 'true' );
			// toggleSidebar();
		} else {
			document.body.classList.remove( 'business-is-active' );
			document.body.classList.remove( 'sidebar-active' );
			toggleBtn.classList.remove( 'is-active' );
			toggleBtn.setAttribute( 'aria-expanded', 'false' );
			// toggleSidebar();
		}
	};

	const init = () => {
		const toggleBtn = document.querySelector( '[rel="toggle-business"]' );
		_setView();
		_toggleInput( toggleBtn );
		_changePosition( toggleBtn );
	};

	return {
		init,
	};
} )( document );

export default toggleBusiness;
